import {
  AuthenticationDetails,
  CognitoUserAttribute,
  CognitoUser,
  CookieStorage,
  CognitoUserPool,
  CognitoRefreshToken
} from 'amazon-cognito-identity-js';

export const COGNITO_CONFIG = {
  UserPoolId: process.env.VUE_APP_COGNITO_USERPOOL_ID,
  ClientId: process.env.VUE_APP_COGNITO_CLIENT_ID
};

export const COGNITO_COOKIES_STORAGE = new CookieStorage({
  secure: process.env.NODE_ENV === 'production',
  domain: process.env.VUE_APP_SESSION_DOMAIN || window.location.hostname
});

export const useCognito = () => {
  const userPool = new CognitoUserPool({ ...COGNITO_CONFIG, Storage: COGNITO_COOKIES_STORAGE });

  const initialize = async () => {
    return new Promise((resolve, reject) => {
      const user = userPool.getCurrentUser();

      console.log('[useCognito.js] retrieve user:', user);

      if (user) {
        user.getSession((error, session) => {
          console.log('[useCognito.js] get session error:', error);

          if (error) {
            user.signOut();

            reject(error);
          }

          console.log('[useCognito.js] check get session:', session);

          resolve({ user, session });
        });
      } else {
        resolve({ user: null, session: null });
      }
    });
  };

  const signIn = async ({ email, password }, { email_verified = false } = {}) => {
    const authDetailData = {
      Username: email,
      Password: password,
      ClientMetadata: {
        email_verified: `${email_verified}`
      }
    };

    const authDetails = new AuthenticationDetails(authDetailData);

    const authUserData = {
      Username: authDetailData.Username,
      Pool: userPool,
      Storage: COGNITO_COOKIES_STORAGE
    };

    const user = new CognitoUser(authUserData);

    return new Promise((resolve, reject) => {
      user.setAuthenticationFlowType('USER_PASSWORD_AUTH');

      user.authenticateUser(authDetails, {
        async onSuccess(session) {
          console.log('[useCognito.js] cognito authenticate success:', session);
          //   await manageSession(null, session);

          //   let encodedUrl = `${window.location.origin}/auth-callback?returnUrl=${encodeURIComponent(
          //     window.location.origin
          //   )}`;

          //   window.location.href = encodedUrl;
          resolve({ user, session });
        },
        async onFailure(err) {
          if (err instanceof Error && err.message === 'Incorrect username or password.') {
            console.error('cognito authenticate failed');
          }
          //   await manageSession(error, null);
          reject(err);
        }
      });
    });
  };

  const refresh = async (token) => {
    return new Promise((resolve, reject) => {
      const user = userPool.getCurrentUser();

      if (user) {
        const refreshToken = new CognitoRefreshToken({ RefreshToken: token });

        user.refreshSession(refreshToken, (error, session) => {
          console.log('[useCognito.js] refresh session error:', { ...error });
          if (error) reject(error);

          console.log('[useCognito.js] check refresh session:', session);

          resolve({ user, session });
        });
      } else {
        resolve({ user: null, session: null });
      }
    });
  };

  const updateProfile = async ({ firstname, lastname } = {}) => {
    const { user } = await initialize();

    if (user) {
      const updatedAttributes = [];

      if (firstname) {
        updatedAttributes.push(
          new CognitoUserAttribute({
            Name: 'given_name',
            Value: firstname
          })
        );
      }

      if (lastname) {
        updatedAttributes.push(
          new CognitoUserAttribute({
            Name: 'family_name',
            Value: lastname
          })
        );
      }

      await user.updateAttributes(updatedAttributes, (error, result) => {
        if (error) Promise.reject(error);

        return Promise.resolve(result);
      });
    }
  };

  const getGoogleUserData = async (accessToken) => {
    const authorizationHeader = `Bearer ${accessToken}`;
    const res = await fetch(`${process.env.VUE_APP_COGNITO_CLIENT_ID}/oauth2/userInfo`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        Authorization: authorizationHeader
      }
    });

    if (!res.ok) {
      console.error('Failed to fetch user info:', res.statusText);
      console.log(res);
    }

    const data = await res.json();
    console.log('User Info:', data);
    return data;
  };

  const refreshGoogleToken = async (refreshToken) => {
    const requestBody = new URLSearchParams({
      grant_type: 'refresh_token',
      client_id: process.env.VUE_APP_COGNITO_CLIENT_ID,
      refresh_token: refreshToken
    });
    // Get tokens

    const res = await fetch(`${process.env.VUE_APP_COGNITO_DOMAIN}/oauth2/token`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: requestBody
    });

    if (!res.ok) {
      console.error('Failed to refresh GoogleSession:', res.statusText);

      throw new Error('Failed to refresh GoogleSession');
    }

    const data = await res.json();
    const session = {
      accessToken: { jwtToken: data.access_token },
      idToken: { jwtToken: data.id_token },
      refreshToken: { token: refreshToken }
    };
    console.log('[useCognito.js] session', session);

    return session;
  };

  return {
    initialize,
    signIn,
    refresh,
    updateProfile,
    getGoogleUserData,
    refreshGoogleToken
  };
};
